import { isEmpty as _isEmpty } from 'lodash';

import jsonApi from '@/services/api/json_api_service';
import resourceService, { filterRelationshipsForUpdate } from './resource_service';

const modelName = 'user';

const attributes = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  passwordConfirmation: '',
  isSuperUser: false,
  isManufacturer: false,
  isSiteAdmin: false,
};

const relationships = {
  userRoles: {
    jsonApi: 'hasMany',
  },
  sites: {
    jsonApi: 'hasMany',
  },
  permissions: {
    jsonApi: 'hasMany',
  },
};

const Resource = resourceService(modelName, attributes, relationships);

Resource.update = (data) => {
  jsonApi.auth();
  filterRelationshipsForUpdate(relationships, data);
  if (_isEmpty(data.password)) {
    delete data.password;
    delete data.passwordConfirmation;
  }
  return jsonApi.update(modelName, data);
};

export default Resource;
